import { ReactKit } from '@team/react';
import { Layout } from './components/layout';
import { Item } from './components/item';

export const CompactPagination = ReactKit.createCompoundComponent(Layout, {
  Item,
});

Layout.displayName = 'CompactPagination';
Item.displayName = 'CompactPaginationItem';
